

export const initFitlerData = {
  AptTmSt: null,
  AptTmEn: null,
  JobOrdId: null,
  JobNo: null,
  CusId: null,
  ContNo: null,
  IsFinJobOrd: 1,
  FullJob: 1,
  IsNoInv: 1,
}

export const initInvData = {
  CusId: null,
  InvNo: "",
  InvId: null,
  InvDte: null,
  RefNo: "",
  Addr: "",
  TaxId: "",
  BrchNo: "",
  Rmk: "",
  PrntTxt: "",
  refno2:"",
  JobNos: "",
  Bkgs: "",
  ShpmIds: [],
  JobIds: [],
  IsXpss: 0,
  Curr: "THB",
  ExRate: null,
}


export const initJOItem = {
  AptTm: "", 
  ArvTm: "",
  LevTm: "",
  JobNo: "",
  FinDte: "",
  RtnDteSt: "",
  Bkg: "",
  Rmk: "",
}

export const initExpenseJobOrderData = {
  ExpJobOrdId: 0,
  IsCost: 0, 
  JobOrdId: null,
  ExpId: null,
  VatPrct:0,
  WhtPrct: 0,
  UntPr: 0,
  UntPrB4Vat: 0,
  Qty: 1,
  Total: 0,
  IsOwnRcpt:1,
  Rmk: ""
}

export const colNmExpId = {
  TransAmnt: 1,
  LiftAmnt: 3,
  DeptAmnt: 5,
  ShorAmnt: 2,
  GateAmnt: 4,
}